// extracted by mini-css-extract-plugin
module.exports = {"marqueeText":"DingTong_marqueeText__kpw7q","ding-tong-marquee":"DingTong_ding-tong-marquee__bZOnL"};